import { useState } from "react";
import { getMagicTags } from "services/magicTags";

export const useGetMagicTags = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const [error, setError] = useState(false);

  const execute = async (gateway, cid) => {
    try {
      setIsLoading(true);
      const res = await getMagicTags(gateway, cid);
      const { data } = res;
      setData(data);
      return data;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };
  return { isLoading, data, error, execute };
};
